var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpwards28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5 3C14.7761 3 15 3.22386 15 3.5V23.5C15 23.7761 14.7761 24 14.5 24C14.2239 24 14 23.7761 14 23.5V3.5C14 3.22386 14.2239 3 14.5 3Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1464 3.14645C14.3417 2.95118 14.6583 2.95118 14.8536 3.14645L21.8536 10.1464C22.0488 10.3417 22.0488 10.6583 21.8536 10.8536C21.6583 11.0488 21.3417 11.0488 21.1464 10.8536L14.5 4.20711L7.85355 10.8536C7.65829 11.0488 7.34171 11.0488 7.14645 10.8536C6.95118 10.6583 6.95118 10.3417 7.14645 10.1464L14.1464 3.14645Z",
  fill: "currentColor"
})));
export default SvgUpwards28;